module.exports = __webpack_public_path__ + "static/media/10.a04fad5f.JPG";